import('@ac/library-utils/dist/utils/ac-config')
  .then(({ fetchAcConfig }) => {
    return fetchAcConfig();
  })
  .then(async () => {
    const { init } = await import('./init');
    init();
  });

export {};
